import '@polymer/polymer/lib/elements/custom-style.js';

//Import default styles
import { defaultStyles } from '@cbar/default-styles';

const $_documentContainer = document.createElement('template');
$_documentContainer.setAttribute('style', 'display: none;');

$_documentContainer.innerHTML = `
<dom-module id="cbar-base-styles">
    <template>
        <style>${defaultStyles}</style>
    </template>
</dom-module>
`;

document.head.appendChild($_documentContainer.content);
